var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookingSummary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    fill: "#55C4F1",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1626 17H35.4388C35.7471 17 36.0428 17.1225 36.2609 17.3405C36.4789 17.5585 36.6014 17.8542 36.6014 18.1626V40.418C36.6015 40.5219 36.5738 40.624 36.521 40.7136C36.4683 40.8031 36.3925 40.8769 36.3016 40.9273C36.2107 40.9776 36.1079 41.0027 36.004 40.9998C35.9001 40.9969 35.7989 40.9662 35.7108 40.9109L27.3007 35.6363L18.8905 40.9097C18.8026 40.965 18.7015 40.9957 18.5977 40.9986C18.4939 41.0015 18.3912 40.9766 18.3003 40.9264C18.2094 40.8762 18.1336 40.8026 18.0808 40.7132C18.028 40.6237 18.0001 40.5218 18 40.418V18.1626C18 17.8542 18.1225 17.5585 18.3405 17.3405C18.5585 17.1225 18.8542 17 19.1626 17ZM34.2762 19.3252H20.3252V37.2662L27.3007 32.8937L34.2762 37.2662V19.3252Z",
    fill: "#55C4F1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingSummary);
export default __webpack_public_path__ + "static/media/bookingSummary.3db65834a378e887a2c8f32069e02fed.svg";
export { ForwardRef as ReactComponent };